import { vservice } from '@niknevis/vue-modules'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { StartPaymentResource } from '@/modules/transaction/models/payment.model'
import { Data } from '@/modules/shared/models/data'
import { PanelWalletRoute } from '@/modules/wallet/routes/panel-wallet.route'
import { WalletIncreaseRequest } from '@/modules/wallet/models/wallet-request.model'

@vservice()
export class PanelWalletService {
  constructor(
    private routes: PanelWalletRoute
  ) {
  }

  paymentLink(data: WalletIncreaseRequest): Promise<Data<StartPaymentResource>> {
    return HTTP
      .post(
        this.routes.paymentLink(),
        data
      ).then(result => result.json())
  }

}
